import { PhoneValidationResult } from "./types"
import { TEL_LENGTH } from "../../../../constants/progressBanner"

export const formatPhoneNumber = (phoneNumber: string): string => {
    return phoneNumber.replace(/[^\d]/g, "")
}

export const validatePhoneNumber = (phone: string): PhoneValidationResult => {
    const formattedPhone = formatPhoneNumber(phone)

    if (/[^\d]/.test(phone)) {
        return {
            isValid: false,
            error: "数字のみ入力してください",
        }
    }

    if (!formattedPhone) {
        return {
            isValid: false,
            error: "入力してください",
        }
    }

    if (
        formattedPhone.length > TEL_LENGTH.MAX ||
        formattedPhone.length < TEL_LENGTH.MIN
    ) {
        return {
            isValid: false,
            error: "電話番号は11桁で入力してください",
        }
    }

    return {
        isValid: true,
        error: "",
    }
}
